import React from "react";
import "./scrollup.css";

const ScrollUp = () => {
    window.addEventListener("scroll" , function () {
        const scrollUp = document.querySelector(".scrollup");
        if (this.scrollY >= 560) scrollUp.classList.add("show-scroll");
        else scrollUp.classList.remove("show-scroll");
    });
    return(
       <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="scrollup" type="button">
       <i className="uil uil-arrow-up scrollup_icon"></i>
       </button>
    );
};

export default ScrollUp;